import {
  Background,
  ColorsBase,
  ColorRoot,
  Stroke,
  Text,
  Icon,
} from "theme/types/color";

const colorsBase: ColorsBase = {
  blue_00: "#1627ba",
  blue_0: "#182bcf",
  blue_1: "#2f40d4",
  blue_2: "#4655d9",
  blue_3: "#5d6bdd",
  blue_4: "#7480e2",
  blue_5: "#8c95e7",
  blue_6: "#a3aaec",
  blue_7: "#babff1",
  blue_8: "#d1d5f5",
  blue_9: "#e8eafa",
  blue_10: "#e4ebff",

  gray_0: "#ffffff",
  gray_opacity_0_5: "#F2F2F2",
  gray_1: "#e6e6e6",
  gray_2: "#cccccc",
  gray_3: "#b3b3b3",
  gray_4: "#999999",
  gray_5: "#808080",
  gray_6: "#666666",
  gray_7: "#4c4c4c",
  gray_8: "#333333",
  gray_9: "#191919",
  gray_10: "#000000",
  gray_11: "#F5F6FF",

  red_0: "#eb2f2f",
  red_1: "#ed4444",
  red_2: "#ef5959",
  red_3: "#f16d6d",
  red_4: "#f38282",
  red_5: "#f59797",
  red_6: "#f7acac",
  red_7: "#f9c1c1",
  red_8: "#fbd5d5",
  red_9: "#fdeaea",

  green_0: "#0ea374",
  green_1: "#26ac82",
  green_2: "#3eb590",
  green_3: "#56bf9e",
  green_4: "#6ec8ac",
  green_5: "#87d1ba",
  green_6: "#9fdac7",
  green_7: "#b7e3d5",
  green_8: "#cfede3",
  green_9: "#e7f6f1",

  orange_0: "#d46b08",
  orange_1: "#d87a21",
  orange_2: "#dd8939",
  orange_3: "#e19752",
  orange_4: "#e5a66b",
  orange_5: "#eab584",
  orange_6: "#eec49c",
  orange_7: "#f2d3b5",
  orange_8: "#f6e1ce",
  orange_9: "#fbf0e6",

  violet_0: "#b424c6",
  violet_1: "#bc3acc",
  violet_2: "#c350d1",
  violet_3: "#cb66d7",
  violet_4: "#d27cdd",
  violet_5: "#da92e3",
  violet_6: "#e1a7e8",
  violet_7: "#e9bdee",
  violet_8: "#f0d3f4",
  violet_9: "#f8e9f9",

  yellow_0: "#b38500",
  yellow_1: "#bb911a",
  yellow_2: "#c29d33",
  yellow_3: "#caaa4d",
  yellow_4: "#d1b666",
  yellow_5: "#d9c280",
  yellow_6: "#e1ce99",
  yellow_7: "#e8dab3",
  yellow_8: "#f0e7cc",
  yellow_9: "#f7f3e6",

  success_0: "#0f7e1514",
  success_1: "#558B2F",
  success_2: "#3eb590",

  gray_opacity_0_2: "rgba(102, 102, 102, 0.2)",
};

const background: Background = {
  bgBase: colorsBase.blue_9,
  bgPrimary: colorsBase.gray_0,
  bgSecondary: colorsBase.gray_1,
  bgMenuBase: colorsBase.blue_0,
  bgMenuBase2: colorsBase.blue_00,
  bgMenuPrimary: colorsBase.gray_0,
  bgMenuSecondary: colorsBase.blue_9,
  bgPositive: colorsBase.green_0,
  bgPositivePrimary: colorsBase.green_8,
  bgPositiveSecondary: colorsBase.green_9,
  bgBrand: colorsBase.blue_0,
  bgBrandPrimary: colorsBase.blue_10,
  bgNegative: colorsBase.red_0,
  bgNegativePrimary: colorsBase.red_9,
  bgWarning: colorsBase.orange_0,
  bgWarningPrimary: colorsBase.orange_9,
  bgTertiary: colorsBase.gray_opacity_0_5,
  bgTable: colorsBase.gray_11,
};

const text: Text = {
  textPrimary: colorsBase.gray_10,
  textSecondary: colorsBase.gray_6,
  textTertiary: colorsBase.gray_5,
  textDisable: colorsBase.gray_3,
  textLink: colorsBase.blue_0,
  textPositive: colorsBase.green_0,
  textWhite: colorsBase.gray_0,
  textNegative: colorsBase.red_0,
  textWarning: colorsBase.orange_0,
};

const stroke: Stroke = {
  strokeDefault: colorsBase.blue_8,
  strokeDefault2: colorsBase.blue_9,
  strokeBrand: colorsBase.blue_0,
  strokePositive: colorsBase.green_0,
  strokePositivePrimary: colorsBase.green_7,
  strokeNegative: colorsBase.red_0,
  strokeDefault7: colorsBase.red_7,
  strokeWarning: colorsBase.orange_0,
  strokeWarningPrimary: colorsBase.orange_7,
  strokeMenu: colorsBase.blue_1,
  strokeGrayOpacity_0_2: colorsBase.gray_opacity_0_2,
};

const icon: Icon = {
  icDefault: colorsBase.gray_6,
  icPrimary: colorsBase.blue_3,
  icDisable: colorsBase.gray_3,
  icBrand: colorsBase.blue_0,
  icPositive: colorsBase.green_0,
  icNegative: colorsBase.red_0,
  icWarning: colorsBase.orange_0,
  icDark: colorsBase.gray_10,
  icLight: colorsBase.gray_0,
};

const colors: ColorRoot = {
  background,
  text,
  stroke,
  icon,
  colorsBase,
};

export default colors;
